const e = {
  value: {
    required: !0,
    type: [String, Number, Boolean, Object]
  },
  label: [String, Number],
  disabled: {
    type: Boolean,
    default: !1
  }
};
export {
  e as optionProps
};
